import { signal } from '@preact/signals';

// Installing Ahillah as an app: Chrome and Edge offer a prompt we can trigger; on iPhone and iPad
// people add it from Safari's Share menu, which a web page cannot open, so we explain the steps.

interface InstallPromptEvent extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

let deferred: InstallPromptEvent | null = null;
export const canPromptInstall = signal(false);

export const isStandalone = () =>
  matchMedia('(display-mode: standalone)').matches || (navigator as unknown as { standalone?: boolean }).standalone === true;
export const isIOSDevice = () => /iPhone|iPad|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  deferred = e as InstallPromptEvent;
  canPromptInstall.value = true;
});
window.addEventListener('appinstalled', () => {
  deferred = null;
  canPromptInstall.value = false;
});

export async function promptInstall(): Promise<boolean> {
  if (!deferred) return false;
  await deferred.prompt();
  const { outcome } = await deferred.userChoice;
  deferred = null;
  canPromptInstall.value = false;
  return outcome === 'accepted';
}
